// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__XnAqm","row":"styles_row__xskEh"};